import { createContext } from "react";

import { memberPaths } from "./member-paths.js";

/**
 * 会員の画面の外へ出る（ページごと読み込む）。
 *
 * <b>差し替えられるようにしてある</b>（テストは jsdom で、ページを移れない）。
 */
export type Leave = (location: string) => void;

export const defaultLeave: Leave = (location) => {
    window.location.assign(location);
};

export const LeaveContext = createContext<Leave>(defaultLeave);

/**
 * この画面の中で開けるか（<c>paths/*.json</c> の一覧にあるか）。
 *
 * <b>無ければページごと移る。</b>まだ静的になっていない画面（テナント一覧ほか）や公開ページは、
 * SWA が別のファイルを返す。大文字小文字は問わない（今のアプリと同じ）。
 */
export const isAppPage = (location: string): boolean => {
    const path = new URL(location, "https://pleasanter.net").pathname.toLowerCase();
    return memberPaths.pages.some((page) => pageMatches(page.toLowerCase(), path));
};

/**
 * 一覧の画面と URL が合うか。<b>一覧には <c>:tenantId</c> のような埋め込みを書ける</b>
 * （React Router のルートと同じ書き方）。
 */
const pageMatches = (page: string, path: string): boolean => {
    const expected = page.split("/");
    const actual = path.split("/");
    return expected.length === actual.length
        && expected.every((part, index) => part.startsWith(":") || part === actual[index]);
};

/** クエリの値。<b>名前の大文字小文字は問わない</b>（サーバは rememberMe=True のように返す）。 */
export const queryValue = (search: URLSearchParams, name: string): string | undefined => {
    const wanted = name.toLowerCase();
    for (const [key, value] of search) {
        if (key.toLowerCase() === wanted) {
            return value;
        }
    }
    return undefined;
};
